
import { defineComponent, reactive } from 'vue'
import { changeLocale } from '@/i18n'
import { useHead } from '@vueuse/head'
import _ from 'lodash'

export default defineComponent({
  name: 'App',
  setup() {
    const siteData = reactive({
      title: 'Scan My Net',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        {
          hid: 'description',
          name: 'description',
          content: 'Earthlink - Scan My Net'
        }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }]
    })
    useHead(siteData)
  },
  watch: {
    '$store.state.toast': {
      deep: true,
      immediate: true,
      handler(v) {
        if (v && !_.isEmpty(v)) {
          this.$toast.add(v)
          this.$store.dispatch('clearToast')
        }
      }
    }
  },

  async beforeMount() {
    const locale = String(localStorage.getItem('language'))
    if (localStorage.getItem('language')) changeLocale(locale)
  }
})
